import { saveBlob } from "@/ajax/documents/saveBlob";

export type InvoiceDocumentPayload = {
  contentBase64: string;
  fileName: string;
  mimeType: string;
};

export async function saveInvoiceDocument({
  contentBase64,
  fileName,
  mimeType,
}: InvoiceDocumentPayload): Promise<void> {
  const binary = atob(contentBase64);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  await saveBlob({ blob: new Blob([bytes], { type: mimeType }), fileName });
}
